import request from '@/utils/request'
const couponApi = {
  // 查询线下卡券
  queryOfflineCouponList: (params) => {
    return request({
      url: '/offline-coupon/wholesaler/list',
      method: 'get',
      params
    })
  },
  // 获取线下券map
  getOfflineCouponVerifyStatusMap: (params) => {
    return request({
      url: '/dictionary/get',
      method: 'get',
      params
    })
  },
  // 获取线下券
  submitOfflineCoupon: (data) => {
    return request({
      url: '/offline-coupon/wholesaler/accept',
      method: 'post',
      data
    })
  },
  queryWrokshopList: (params) => {
    return request({
      url: '/offline-coupon/workshop/list',
      method: 'get',
      params
    })
  },
  getCouponList: (params) => {
    return request({
      url: '/coupon/list',
      method: 'get',
      params
    })
  },
  // 卡券兑换积分
  obtainPoint: (data) => {
    return request({
      url: '/coupon/obtain-point',
      method: 'post',
      data
    })
  },
  // 兑换卡券
  exchangeCoupon: (data) => {
    return request({
      url: '/coupon/gift-code/take',
      method: 'post',
      data
    })
  }
}

export default couponApi
